import React from "react";
import { Text, Grid, Row, Col, Divider, } from "rsuite";
import { formatPhoneNumber } from "./helper";
import { titleize } from "../../../common/utils";

const PropertyContact = ({ data, roles }) => {
  return (
    <Grid fluid className="property-contact content-section">
      <Row className="mb-4">
        <Col xs={24} sm={12} md={12} lg={12}>
          <Text className="text-extra-large text-bold mb-4">{data?.name}</Text>
          {
            data.companyName && (
              <Text className="text-large">{data?.companyName}</Text>
            )
          }
        </Col>
        <Col xs={12} sm={12} md={12} className="pt-16-sm">
          <div role="grid">
            {
              roles.map((role, i) => (
                <Row key={i} className="mb-4">
                  <Col xs={24} className="contact-right-align">
                    <Text className="grey-text">{role}</Text>
                  </Col>
                </Row>
              ))
            }
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Divider style={{margin: '15px 0px'}} />
        </Col>
      </Row>
      <Row className="mb-16">
        <Col xs={24}>
          <Text className="grey-text">Mailing Address</Text>
          <Text className="text-large">{titleize(data?.address)}</Text>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={16}  className="pb-16-sm">
          <Text className="grey-text">Email Address</Text>
          <a className="text-large" style={{ wordBreak: 'break-word', color: 'unset' }} href={`${data?.email}`}>{data?.email}</a>
        </Col>
        <Col xs={24} sm={8}  className="pb-16-sm contact-right-align">
          <Text className="grey-text contact-phone">Phone</Text>
          <Text className="text-large">{formatPhoneNumber(data?.primaryPhone)}</Text>
        </Col>
      </Row>
    </Grid>
  );
};

export default PropertyContact; 
